import isNil from 'lodash-es/isNil';
import moment from 'moment-timezone';
import { isNumber } from 'lodash-es';
const VALUE_BOUNDARIES = 500; //Maximum and minimum values used to layer markers
const FLOATING_VALUE_FACTOR = 10; //10 means 1 digit after comma of rawValue is used to layer markers, 100 means 2, ect
const isWinter = () => {
    const year = moment(Date.now()).format('YYYY');
    const startOfYearWinterEndDate = moment(`13/05/${year}`, 'DD/MM/YYYY');
    const endOfYearWinterStartDate = moment(`13/11/${year}`, 'DD/MM/YYYY');
    /** Used to determine marker ordering depending on season */
    const isInStartOfYearWinter = moment(Date.now()).isSameOrBefore(startOfYearWinterEndDate, 'days');
    const isInEndOfYearWinter = moment(Date.now()).isSameOrAfter(endOfYearWinterStartDate, 'days');
    return isInStartOfYearWinter || isInEndOfYearWinter;
};
const orderMarkerBasedOnValue = (metricId) => {
    return (metricId === 'T' && isWinter()) || metricId === 'T_WET' || metricId === 'T_DRY' ? -1 : 1;
};
export const getZIndex = ({ isFocused, metricId, rawValue, isFavorite, isCluster }) => {
    // Order of markers from top to bottom :
    // Focused Marker/Cluster
    // Favorite Marker with Data (highest value on top)
    // Marker with Data (highest value on top)
    // Cluster with Data
    // Favorite marker without Data
    // Marker without Data
    // Cluster without Data
    // Highest value might depend on metric and season (e.g coldest temp in winter / hottest temp in summer)
    let zIndexDependingOnValue = 10 * FLOATING_VALUE_FACTOR * VALUE_BOUNDARIES + 1;
    if (isFocused) {
        zIndexDependingOnValue = 20 * FLOATING_VALUE_FACTOR * VALUE_BOUNDARIES;
        return zIndexDependingOnValue;
    }
    if (!isNil(rawValue) && (isNumber(rawValue) || !isNaN(parseFloat(rawValue)))) {
        const value = isNumber(rawValue) ? rawValue : parseFloat(rawValue);
        const boundedValue = Math.max(-VALUE_BOUNDARIES + 1, Math.min(VALUE_BOUNDARIES - 1, value)) * FLOATING_VALUE_FACTOR;
        zIndexDependingOnValue += Math.round(boundedValue) * orderMarkerBasedOnValue(metricId);
    }
    else {
        zIndexDependingOnValue -= 8 * FLOATING_VALUE_FACTOR * VALUE_BOUNDARIES;
    }
    if (isFavorite) {
        zIndexDependingOnValue += 4 * FLOATING_VALUE_FACTOR * VALUE_BOUNDARIES;
    }
    if (isCluster) {
        zIndexDependingOnValue -= 2 * FLOATING_VALUE_FACTOR * VALUE_BOUNDARIES;
    }
    return zIndexDependingOnValue;
};
